import {Typography} from "@mui/material";
import {PropsWithChildren} from "react";

export function SectionTitle(props: PropsWithChildren<{}>) {
    return (
        <Typography variant="h2" style={{fontSize: "1.2rem", fontWeight: 500}}>{props.children}</Typography>
    )
}